import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { heIL } from '@mui/x-date-pickers/locales';
import he from 'date-fns/locale/he';

/**
 * spec 000231 — one localization for every MUI X picker in the app.
 *
 * Owner standing rule (2026-10-12): every time picker is 24-hour `HH:mm`, never AM/PM. The Hebrew
 * date-fns locale formats time as 24-hour, and the pickers' own texts (OK / Cancel / aria labels)
 * come from MUI X's Hebrew pack.
 *
 * Mounted once at the app root (src/index.js). Primitives that render a picker mount it again around
 * themselves so they behave the same in a unit test with no app root; nested providers are supported.
 */
export const PICKER_LOCALE_TEXT = heIL.components.MuiLocalizationProvider.defaultProps.localeText;

const AppPickerLocalization = ({ children }) => (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={he} localeText={PICKER_LOCALE_TEXT}>
        {children}
    </LocalizationProvider>
);

AppPickerLocalization.propTypes = {
    children: PropTypes.node,
};

export default AppPickerLocalization;
